module.exports = __webpack_public_path__ + "fonts/fa-regular-400.b01516c1.eot";